import React, { FC } from 'react';
import { MotionBox } from '@olo-web/components/atoms/motion';
import { Icon, Tooltip } from '@chakra-ui/react';
import { Star } from 'react-feather';

interface I {
  color: string;
  layoutId: string;
  isMain: boolean;
}

const spring = {
  type: 'spring',
  stiffness: 500,
  damping: 30,
};

export const AnimatedColorBox: FC<I> = (props) => {
  const { color, layoutId, isMain } = props;

  return (
    <MotionBox
      layoutId={layoutId}
      initial={false}
      transition={spring}
      bg={color}
      h={{ base: 9, md: 12 }}
      w={{ base: 9, md: 12 }}
      borderRadius="md"
      pos="relative"
    >
      {isMain && (
        <Tooltip
          label="This is main color in this collection"
          aria-label="A tooltip explaining this is the main color in this collection"
        >
          <Icon
            as={Star}
            pos="absolute"
            top={1}
            right={1}
            color="whiteAlpha.900"
            strokeWidth="3px"
          />
        </Tooltip>
      )}
    </MotionBox>
  );
};
